if ( $(window).outerWidth() >= 992 ) {
  let parallaxAttr = 'data-parallax'
  let parallaxElem = $('[' + parallaxAttr + ']')
  let parallaxBaseTranslateY = 'data-parallax-translate-y'
  let parallaxBaseTranslateX = 'data-parallax-translate-x'

  parallaxElem.each(function setVal () {
    let that = $(this)

    let info = that.css('transform');

    let y = info.split(',')[5]
    let x = info.split(',')[4]


    if (!y) {
      y = 0
    } else {
      y = y.replace(')', '')
    }
    if (!x) {
      x = 0
    }

    that.attr(parallaxBaseTranslateY, y)
    that.attr(parallaxBaseTranslateX, x)
  })

  function parallax(){
    let scrolled = $(window).scrollTop()

    parallaxElem.each(function () {
      let that = $(this)
      let multiplier = that.attr(parallaxAttr) / 10
      let translateY = that.attr(parallaxBaseTranslateY)
      let translateX = that.attr(parallaxBaseTranslateX)

      that.css({
        'transform': 'translate(' + translateX + 'px, calc(' + translateY + 'px + ' + -(scrolled * -multiplier) + 'px))'
      })
    })
  }


  $(window).scroll(function(){
    parallax()
  })
}
